import { atom } from 'jotai';

export const viewPracticeGroupsAtom = atom<boolean>(false);
export const isViewingEngagementAtom = atom<boolean>(false);
